import * as React from 'react';

const Clock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 2L12.28 2.004C17.673 2.152 22 6.57 22 12L21.996 12.28C21.848 17.673 17.43 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20L12.25 19.996C16.551 19.865 20 16.335 20 12L19.996 11.75C19.865 7.449 16.335 4 12 4ZM12 7C12.552 7 13 7.448 13 8V11H16C16.552 11 17 11.448 17 12C17 12.552 16.552 13 16 13H12C11.448 13 11 12.552 11 12V8C11 7.448 11.448 7 12 7Z" fill="currentColor"/>
  </svg>
);

export default Clock;
